import { render } from "./DashboardMoatCompsModal.vue?vue&type=template&id=5cd0bc6e"
import script from "./DashboardMoatCompsModal.vue?vue&type=script&lang=js"
export * from "./DashboardMoatCompsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__